module.exports = __webpack_public_path__ + "static/media/OcapLogo.0c89c056.png";